import styled from 'styled-components';
import { Breadcrumb as breadcrumb, BreadcrumbItem as item } from 'reactstrap';

const resolveBackgroundColor = ({ background, theme }) => {
  if (!background) {
    return 'transparent';
  }

  if (theme.colors[background]) {
    return theme.colors[background];
  }

  const resolvedPathColor = background
    .split('.')
    .reduce((acc, currentKey) => (acc ? acc[currentKey] : undefined), theme);

  return resolvedPathColor || background;
};

export const Breadcrumb = styled(breadcrumb)`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  align-items: center;
  color: ${props => props.theme.colors.breadcrumb};

  ol.breadcrumb {
    background-color: ${resolveBackgroundColor} !important;
    padding: 0;
    margin-bottom: 8px;
  }
`;

export const BreadcrumbItem = styled(item)`
  color: ${props => props.theme.colors.breadcrumb};

  & + &::before {
    display: inline-block;
    padding-right: 0.5rem;
    color: ${props => props.theme.colors.breadcrumb};
    content: '>';
  }

  a {
    color: ${props => props.theme.colors.breadcrumb};
    &:hover {
      color: ${props => props.theme.colors.primary500};
    }
  }
`;

export default Breadcrumb;
